import * as feed from 'settings/feed';
import * as groups from 'settings/groups';

export default {
  ...feed.settings,
  ...groups.settings,
};
